import {UserLocationApiDto} from "../../api/model/rest";
import UserLocationStatus, {UserLocationStatusEnum} from "./UserLocationStatus";
import moment = require("moment");

export default class UserLocation {

	constructor(public readonly createdAt: moment.Moment,
		public readonly latitude: number,
		public readonly longitude: number,
		public readonly status: UserLocationStatus,
		public readonly userId: string) {}

	static fromJson(json: UserLocationApiDto): UserLocation {
		return new UserLocation(moment(json.createdAt), json.latitude, json.longitude, UserLocationStatus.fromString(json.status),
			json.userId)
	}

	copy({createdAt = this.createdAt, latitude = this.latitude, longitude = this.longitude, status = this.status, userId = this.userId}) {
		return new UserLocation(createdAt, latitude, longitude, status, userId);
	}

	isOffline() {
		const now = moment();
		if (this.status.value === UserLocationStatusEnum.Stationary) {
			return this.createdAt.isBefore(now.subtract(3, "hours"));
		}
		else {
			return this.createdAt.isBefore(now.subtract(30, "minutes"));
		}
	}
}
